// extracted by mini-css-extract-plugin
export default {"loader":"classes_loader__Wj+qy"};